'use client';

import Link from 'next/link';
import { useRouter } from 'next/navigation';

export default function NotFoundPage() {
  const router = useRouter();

  return (
    <main className="min-h-screen bg-gradient-to-b from-blue-50 to-white">
      <div className="container mx-auto flex min-h-screen flex-col items-center justify-center px-4 py-12 md:flex-row md:gap-16">
        {/* SVG Illustration Section - No image required */}
        <div className="mb-10 md:mb-0 md:w-1/2">
          <div className="mx-auto w-full max-w-xs">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 500 400"
              className="w-full"
            >
              <circle cx="250" cy="200" r="150" fill="#EFF6FF" />
              <path
                d="M250 100L300 200L250 300L200 200Z"
                fill="#3B82F6"
                fillOpacity="0.2"
                stroke="#3B82F6"
                strokeWidth="2"
              />
              <path
                d="M250 100L300 200L250 300L200 200Z"
                fill="none"
                stroke="#3B82F6"
                strokeWidth="2"
                strokeDasharray="10 5"
              />
              <circle
                cx="250"
                cy="200"
                r="30"
                fill="#3B82F6"
                fillOpacity="0.5"
              />
              <text
                x="250"
                y="200"
                textAnchor="middle"
                dominantBaseline="middle"
                fontFamily="Arial"
                fontSize="40"
                fontWeight="bold"
                fill="#1E40AF"
              >
                404
              </text>
              <path
                d="M150 100L350 300M350 100L150 300"
                stroke="#EF4444"
                strokeWidth="3"
                strokeLinecap="round"
              />
            </svg>
          </div>
        </div>

        {/* Content Section */}
        <div className="md:w-1/2">
          <div className="text-center md:text-left">
            <span className="mb-3 inline-block rounded-full bg-blue-100 px-4 py-1.5 text-sm font-medium text-blue-600">
              Page Not Found
            </span>
            <h5 className="text-4xl font-bold text-gray-900 sm:text-5xl">
              Lost on Your Wellness Journey?
            </h5>
            <p className="mt-4 text-lg text-gray-600">
              We couldn&apos;t find the page you&apos;re looking for, but we can
              help guide you back.
            </p>

            {/* Action Buttons */}
            <div className="mt-8 flex flex-col gap-4 sm:flex-row">
              <button
                onClick={() => router.back()}
                className="flex items-center justify-center gap-2 rounded-lg bg-blue-600 px-6 py-3 font-medium text-white transition-colors hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
              >
                <ArrowLeftIcon />
                Go Back
              </button>
              <Link
                href="/"
                className="flex items-center justify-center gap-2 rounded-lg border border-blue-600 px-6 py-3 font-medium text-blue-600 transition-colors hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
              >
                <HomeIcon />
                Return Home
              </Link>
            </div>

            {/* Quick Links */}
            {/* <div className="mt-10">
              <h3 className="mb-3 text-sm font-semibold uppercase tracking-wider text-gray-500">
                Popular Resources
              </h3>
              <div className="flex flex-wrap justify-center gap-4 md:justify-start">
                <Link
                  href="/services"
                  className="rounded-lg bg-blue-50 px-4 py-2 text-blue-600 hover:bg-blue-100"
                >
                  Treatment Programs
                </Link>
                <Link
                  href="/about"
                  className="rounded-lg bg-blue-50 px-4 py-2 text-blue-600 hover:bg-blue-100"
                >
                  Our Approach
                </Link>
                <Link
                  href="/contact"
                  className="rounded-lg bg-blue-50 px-4 py-2 text-blue-600 hover:bg-blue-100"
                >
                  Contact Therapists
                </Link>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </main>
  );
}

// Reusable Icons
const ArrowLeftIcon = () => (
  <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
    <path
      fillRule="evenodd"
      d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z"
      clipRule="evenodd"
    />
  </svg>
);

const HomeIcon = () => (
  <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
    <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
  </svg>
);
